import { vehiclePhotosEmail, VehiclePhotosEmailProps } from './sendPhotosEmail';

export const mailTemplates = {
  vehiclePhotosEmail,
}; 